export const IGetThemeUseCaseType = Symbol('IGetThemeUseCase');
